<template>
  <div id="modalDiv">
    <div id="modalContent">
        Are you sure you want to retake the pretest?
        <hr>
        <div id="modalButtonContainer">
            <button class="modalButton" @click="retakePretest">Yes</button>
            <button class="modalButton" @click="closeModal">Cancel</button>
        </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'RetakeModal',
  props: {
    
  },
  computed: {
    ...mapGetters([

    ])
  },
  methods: {
    ...mapActions([
      'retakePretest',
      'closeModal'
    ]),
  },
  data(){
    return {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #modalDiv{
        position: absolute;
        top: 0;
        z-index: 5;
        height: 100%;
        width: 100%;
        background-color: rgba(0,0,0,0.7);
        display: flex;
        align-items: center;
    }
    #modalContent{
        position: relative;
        width: 400px;
        height: 150px;
        background-color: #ffffff;
        margin: 0 auto;
        text-align: center;
        padding: 20px;
        box-sizing: border-box;   
    }
    #modalContent hr{
        margin-top: 15px;
        width: 200px;
        color: #333;
    }
    #modalButtonContainer{
        margin: 25px auto;
    }

    .modalButton{
        cursor: pointer;
        margin-left: 10px;
        background-color: #97cb59;
        color: #ffffff;
        font-weight: bolder;
        font-size: 20px;
        border: none;
        border-radius: 7px;
        height: 50px;
        width: 150px;
        box-shadow: inset 4px 0px 12px 0px rgba(0,0,0,0.5);
        -moz-box-shadow: inset 4px 0px 12px 0px rgba(0,0,0,0.5);
        -webkit-box-shadow: inset 4px 0px 12px 0px rgba(0,0,0,0.5);
        -o-box-shadow: inset 4px 0px 12px 0px rgba(0,0,0,0.5);
    }

    .modalButton:hover{
        background-color: #88b750;
    }
</style>
